<template>
  <base-card @close="close">
    <div id="automation-creation-wrapper">
      <heading :heading="activeComponent.heading" />
      <Component
        :is="activeComponent"
        :automation="subject"
        :errors="errors"
        @name-input="nameInput"
        @type-input="typeInput"
        @distance-input="distanceInput"
        @timeframe-input="timeframeInput"
        @direction-input="directionInput"
        @email-input="emailInput"
        @subject-input="subjectInput"
        @content-input="contentInput"
        @immediate-input="immediateInput"
        @trigger-input="triggerInput"
        @approval-input="approvalInput"
      />
      <div class="button-container">
        <Button text="Back" @click="back" /><Button text="Next" @click="next" />
      </div></div
  ></base-card>
</template>
<script>
import Button from "@/Components/UI/Button.vue";
import Heading from "@/Components/UI/Heading.vue";
import BaseCard from "@/Components/UI/FloatingCards/BaseFloatingCard.vue";
import Content from "./Content.vue";
import DistanceTimeFrame from "./DistanceTimeframeDirection.vue";
import NameAndType from "./NameAndType.vue";
import Toggles from "./Toggles.vue";

export default {
  data() {
    return {
      activeComponentIndex: undefined,
      activeComponent: undefined,
      errors: {
        title: false,
        distance: false,
        from: false,
        subject: false,
        content: false,
      },
      components: {
        NameAndType: {
          heading: "Name and Type",
          buttons: ["Close", "Next"],
        },
        Toggles: {
          heading: "Options",
          buttons: ["Back", "Next"],
        },
        DistanceTimeFrame: {
          buttons: ["Back", "Next"],
        },
        Content: {
          buttons: ["Back", "Save"],
        },
      },
      subject: {
        id: "automation" + Date.now(),
        title: undefined,
        contactType: "client",
        applyToExistingEvents: false,
        approved: true,
        trigger: {
          quantity: "weeks",
          distance: undefined,
          trigger: "event-date",
          direction: "before",
          immediate: false,
        },
        action: {
          type: "email",
          email: {
            to: undefined,
            from: undefined,
            replyTo: undefined,
            subject: undefined,
            content: undefined,
          },
          toDo: {
            content: undefined,
          },
        },
      },
    };
  },
  methods: {
    back() {
      if (this.activeComponentIndex > 0) {
        this.activeComponentIndex--;
      } else {
        // todo : make this work like next();
        this.close();
      }
    },
    next() {
      let cont = (component) => {
        this.activeComponent = component;
      };
      switch (this.activeComponent) {
        case "NameAndType":
          if (!this.subject.title) {
            this.errors.title = true;
            break;
          } else {
            cont("Toggles");
          }
          break;
        case "Toggles":
          if (this.subject.trigger.immediate) {
            cont("Content");
          } else {
            cont("DistanceTimeFrame");
          }
          break;
        case "DistanceTimeFrame":
          if (!this.subject.trigger.distance) {
            this.errors.distance = true;
            break;
          } else {
            cont("Content");
          }
          break;
        case "Content":
          if (!this.subject.action.email.subject) {
            this.errors.subject = true;
          } else {
            this.errors.subject = false;
          }
          if (!this.subject.action.email.content) {
            this.errors.content = true;
          } else {
            this.errors.content = false;
          }
          if (this.errors.content || this.errors.subject) {
            break;
          } else {
            this.$emit("add-automation", this.subject);
          }
          break;
      }
    },
    close() {
      this.$emit("close");
    },
    async addAutomation() {
      this.$emit("add-automation", this.subject);
    },
    nameInput(value) {
      this.subject.title = value;
    },
    typeInput(value) {
      this.subject.contactType = value;
    },
    distanceInput(val) {
      this.subject.trigger.distance = val;
    },
    timeframeInput(val) {
      this.subject.trigger.quantity = val;
    },
    directionInput(val) {
      this.subject.trigger.direction = val;
    },
    triggerInput(val) {
      this.subject.trigger.trigger = val;
    },
    emailInput(val) {
      this.subject.action.email.from = val;
    },
    subjectInput(val) {
      this.subject.action.email.subject = val;
    },
    contentInput(val) {
      this.subject.action.email.content = val;
    },
    immediateInput(val) {
      if (val === true) {
        this.subject.trigger = {
          quantity: undefined,
          distance: undefined,
          trigger: undefined,
          direction: undefined,
          immediate: true,
        };
      } else {
        this.subject.trigger.immediate = false;
      }
    },
    approvalInput(val) {
      this.subject.approved = val;
    },
  },
  components: {
    BaseCard,
    Button,
    Heading,
    NameAndType,
    Toggles,
    DistanceTimeFrame,
    Content,
  },
  created() {
    this.activeComponent = "NameAndType";
    if (this.automation) {
      this.subject = this.automation;
    }
  },
  props: ["automation", "mode"],
  emits: ["close", "add-automation"],
};
</script>
<style scoped>
@media screen {
  .button-container {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
  }

  .scs-button {
    margin: 5px;
  }
  @media (min-width: 800px) {
    #automation-creation-wrapper {
      width: 70vw;
    }
  }
}
</style>
